/**
 * Shared jsPDF / autoTable helpers to avoid footer overlap and cramped columns.
 */

export const PDF_BOTTOM_MARGIN = 28;

export const createLandscapePdf = (jsPDF) =>
  new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

export const createPortraitPdf = (jsPDF) =>
  new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

export const standardAutoTableOptions = (extra = {}) => ({
  theme: 'grid',
  styles: {
    fontSize: 7,
    cellPadding: 1.5,
    overflow: 'linebreak',
    valign: 'middle',
    halign: 'center',
  },
  headStyles: {
    fillColor: [41, 128, 185],
    textColor: 255,
    fontStyle: 'bold',
    fontSize: 7,
    halign: 'center',
    valign: 'middle',
    overflow: 'linebreak',
  },
  alternateRowStyles: { fillColor: [245, 245, 245] },
  margin: { left: 10, right: 10, top: 12, bottom: PDF_BOTTOM_MARGIN },
  ...extra,
});

export const drawCenteredFooter = (pdf, schoolName) => {
  const totalPages = pdf.getNumberOfPages();
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(7);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(80, 80, 80);
    pdf.text(
      `Generated on: ${new Date().toLocaleDateString()} | ${schoolName || 'Ummu Dhardha Ladies Islamic College'}`,
      pageWidth / 2,
      pageHeight - 10,
      { align: 'center' }
    );
  }
};

export const drawSchoolFooterBand = (pdf, schoolData = {}) => {
  const totalPages = pdf.getNumberOfPages();
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const footerY = pageHeight - 18;

  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setDrawColor(180);
    pdf.setLineWidth(0.3);
    pdf.line(10, footerY - 4, pageWidth - 10, footerY - 4);

    pdf.setFontSize(7);
    pdf.setTextColor(60, 60, 60);
    pdf.setFont('helvetica', 'bold');
    pdf.text(schoolData.schoolName || 'Ummu Dhardha Ladies Islamic College', 12, footerY);
    pdf.setFont('helvetica', 'normal');
    const contact = `Tel: ${schoolData.schoolPhoneNumber || ''} | Email: ${schoolData.schoolEmail || ''}`;
    pdf.text(contact, pageWidth - 12, footerY, { align: 'right' });
    pdf.text(schoolData.schoolAddress || '', pageWidth / 2, footerY + 5, { align: 'center', maxWidth: pageWidth - 24 });
  }
};

/**
 * Place a short trailing block (signatures / summary) without creating a
 * nearly-empty extra page. Prefers squeezing onto the current page.
 * @returns {number} Y position to draw at
 */
export const getTrailingBlockY = (pdf, startY, neededHeight = 22, bottomPad = 14) => {
  const pageHeight = pdf.internal.pageSize.getHeight();
  const bottomLimit = pageHeight - bottomPad;
  const preferredY = startY + 10;

  if (preferredY + neededHeight <= bottomLimit) {
    return preferredY;
  }

  // Enough leftover space under the table — pin block to bottom of this page
  const tableEnd = startY;
  if (bottomLimit - tableEnd >= neededHeight + 2) {
    return bottomLimit - neededHeight;
  }

  // Truly no room: new page, but start near top (avoid empty-looking page)
  pdf.addPage();
  return 20;
};

/** Common autoTable margin that reserves room for a short signature band */
export const tableMarginWithSignatureRoom = {
  left: 10,
  right: 10,
  top: 12,
  bottom: 32,
};
